<template>
    <div class="simpleTopic_style" @click.stop>
        <div class="simpleTopic_line_title">
            <h3>试题间距调整</h3>
            <el-checkbox v-model="line" :true-label="1" :false-label="0">作答线</el-checkbox>
        </div>
        <div class="simpleTopic_style_space">
            <label>间距</label>
            <input ref="rowInput" type="text" v-model.trim="row" maxlength="2" @input="setRow" />
            <label>行</label>
        </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
    methods: {
        setRow(){
            if(!this.row){
                this.row = 0
            }
        },
        spacingHide(){//关闭设置行距
            this.$emit('spacingHide')
        },
    },
    computed: {
        assemblyData(){
            return $store.state.assemblyData
        },
        currentNode(){
            return $store.state.currentNode
        },
        row:{//间距
            set(val){
                val = Math.floor(val)
                val = val>20?20:val
                val = val<0?0:val
                if(this.currentNode.length == 2){
                    $store.commit('RENEWASSEMBLESTORE',{name:['segment_list',this.currentNode[0],'questions',this.currentNode[1],'padding_bottom'],value:val})
                }
                if(this.currentNode.length == 3){
                    $store.commit('RENEWASSEMBLESTORE',{name:['segment_list',this.currentNode[0],'questions',this.currentNode[1],'question_list',this.currentNode[2],'padding_bottom'],value:val})
                }
            },
            get(){
                if(this.currentNode.length == 2){
                    return this.assemblyData.segment_list[this.currentNode[0]].questions[this.currentNode[1]].padding_bottom
                }
                if(this.currentNode.length == 3){
                    return this.assemblyData.segment_list[this.currentNode[0]].questions[this.currentNode[1]].question_list[this.currentNode[2]].padding_bottom
                }
            }
        },
        line:{
            set(val){
                val = val == 1 ? 1 : 0
                if(this.currentNode.length == 2){
                    $store.commit('RENEWASSEMBLESTORE',{name:['segment_list',this.currentNode[0],'questions',this.currentNode[1],'padding_underline'],value:val})
                }
                if(this.currentNode.length == 3){
                    $store.commit('RENEWASSEMBLESTORE',{name:['segment_list',this.currentNode[0],'questions',this.currentNode[1],'question_list',this.currentNode[2],'padding_underline'],value:val})
                }
            },
            get(){
                if(this.currentNode.length == 2){
                    let stat = this.assemblyData.segment_list[this.currentNode[0]].questions[this.currentNode[1]].padding_underline || 0
                    return Number(stat)
                }
                if(this.currentNode.length == 3){
                    let stat = this.assemblyData.segment_list[this.currentNode[0]].questions[this.currentNode[1]].question_list[this.currentNode[2]].padding_underline || 0
                    return Number(stat)
                }
            }
        }
    },
    mounted () {
        this.$nextTick(()=>{
            this.$refs.rowInput.focus()
        })
        document.addEventListener('mouseup',this.spacingHide)
    },
    destroyed () {
        document.removeEventListener('mouseup',this.spacingHide)
    }
}
</script>




// WEBPACK FOOTER //
// packages/question-assembly/src/leftStyle.vue